module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9f0eecc2f15f32ee8287decd10ef29a8.png";